export enum GameState {
  pick,
  reveal,
  gameOver,
}
